module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1"
    }
  }, [_vm._v("1 It’s All Relative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2"
    }
  }, [_vm._v("2 We’re Pregnant! Growing Bellies, Nest Building, and Arrival")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2#ch2sec1"
    }
  }, [_c('em', [_vm._v("Pregnancy: Boy, Isn’t This Fun?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2#ch2sec2"
    }
  }, [_c('em', [_vm._v("When Coffee Smells Like Sh*t and Other Food Oddities")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2#ch2sec3"
    }
  }, [_c('em', [_vm._v("What You Never Expected to Expect")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2#ch2sec4"
    }
  }, [_c('em', [_vm._v("Can I Build My Nest, Please?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2#ch2sec5"
    }
  }, [_c('em', [_vm._v("Born Up a Tree: When Labor Happens, It Just . . . Happens")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Your Bundle of Joy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Aren’t I Cute?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Are You Mine?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Let’s Imprint")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("You Sound Familiar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("What Is That Smell?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Touch Me, Clutch Me, Hold Me Close")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch3sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Why Cry?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Adjusting to Parenthood: The Physical, Mental, and Social Challenges")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch4sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Everything Changes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch4sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Have I Lost My Other Mind?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch4sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Parent Club")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Parenting: Breast Is Best and Other Controversies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch5sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("What’s All the Fuss over Milk?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch5sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Crunchy Granola Parenting")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch5sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Staying at Home Versus Being a Working Parent")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch5sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("What’s with All the Guilt?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 We Are Family")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch6sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Let’s Have More!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch6sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Playing Favorites")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch6sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sibling Rivalry")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 They Grow Up So Fast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch7sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Feed Yourself!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch7sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nighty Night!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch7sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Building Confidence")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch7sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Learning to Get Along")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch7sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Time to Fly")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 No! The Nature of Discipline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8#ch8sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("How Old Are You?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8#ch8sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Come Here! Come Here! Come Here!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8#ch8sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Knee-Jerk No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8#ch8sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("When Things Go Terribly Wrong: Maladaptive Behavior")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Different Families")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#ch9sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Is Divorce Really All That Bad?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#ch9sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Single Parent")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#ch9sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Stepfamily")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#ch9sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Adoption: Raising Kids Who Aren’t Yours")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#ch9sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Does It Really Take a Village?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 A Return to Our Roots")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbb"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbb"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0